<template lang="pug">
.search-result(v-if="result")
	.search-result__content
		.content__image(v-if="result.image")
			img.content__src(:src="result.image")
		.content__details
			.content__eyebrow
				label.content__eyebrow-content {{ result.meta.type }}
				label.content__eyebrow-content {{ result.meta.topic }}
			p.content__title {{ result.title }}
			p.content__summary(v-html="result.summary")
			a.content__cta.btn.btn--link(:href="result.url" :target="result.meta.openInNewWindow") {{ result.meta.buttonText }}
</template>

<script>
export default {
	name: "FlowResult",
	props: {
		result: Object,
		openInNewWindow: Boolean,
		formatDate: Function,
	},
	computed: {},
	methods: {}
};
</script>
<style lang="scss" scoped>
.search-result {
	cursor: unset;
	padding: 0 0 2rem 0;
	border-bottom: 1px solid #E1E1E1;
	margin-bottom: .5rem;

	&__content {
		display: flex;
		gap: 1.5rem;
    @include mqdn(lg) {
      flex-direction: column;
    }
		.content {
			&__image {
				margin: auto 0;
				flex: 0 0 15rem;
				height: 12.5rem;
			}

			&__src {
				height: 100%;
				width: 100%;
				object-fit: cover;
			}

			&__details {
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
			}

			&__eyebrow {
				margin-bottom: 1rem;
				&-content {
					font-size: .875rem;
					color: #767676;
					text-transform: uppercase;
					&:first-of-type {
						border-right: 1px solid #767676;
						padding-right: 1rem;
						margin-right: 1rem;
					}
				}
			}
			&__title {
				font-size: 1.875rem;
				font-weight: 500;
				color: #103846;
				margin-bottom: 1rem;
			}
			&__summary {
				color: #41535D;
				margin-bottom: 1rem;
			}
			&__cta {
				margin-right: auto;
				color: $black !important;
			}
		}
	}
}
</style>
